import React, { useState } from "react";
import { MENU } from "../data/menu";
import { useReveal } from "../hooks/useReveal";

export default function Menu() {
  const [active, setActive] = useState(MENU[0].id);
  const titleRef = useReveal();
  const contentRef = useReveal();

  const current = MENU.find((c) => c.id === active);

  return (
    <section
      id="speisekarte"
      data-testid="menu-section"
      className="relative py-24 md:py-32 px-6 bg-ink-soft"
    >
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 reveal" ref={titleRef}>
          <p className="text-gold tracking-[0.4em] text-xs uppercase mb-4">Kulinarisches</p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white">
            Unsere <span className="italic text-gradient-gold">Speisekarte</span>
          </h2>
          <p className="text-white/65 mt-4 max-w-xl mx-auto">
            Eine Auswahl griechischer Klassiker und mediterraner Köstlichkeiten –
            zubereitet mit Leidenschaft.
          </p>
          <div className="gold-divider w-24 mx-auto mt-6" />
        </div>

        {/* Category tabs */}
        <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-12 reveal" ref={contentRef}>
          {MENU.map((cat) => (
            <button
              key={cat.id}
              onClick={() => setActive(cat.id)}
              data-testid={`menu-tab-${cat.id}`}
              className={`px-4 md:px-5 py-2 md:py-2.5 rounded-full text-xs md:text-sm tracking-wide transition-all duration-300 border ${
                active === cat.id
                  ? "bg-gold text-black border-gold shadow-lg shadow-gold/20"
                  : "border-gold/25 text-white/75 hover:text-gold hover:border-gold/60"
              }`}
            >
              {cat.title}
            </button>
          ))}
        </div>

        {/* Items */}
        <div
          key={current.id}
          data-testid={`menu-content-${current.id}`}
          className="glass-panel rounded-2xl p-6 md:p-12 animate-fade-up"
          style={{ opacity: 0, animationDelay: "0.05s" }}
        >
          <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-8 gap-2">
            <h3 className="font-serif text-3xl md:text-4xl text-gradient-gold">
              {current.title}
            </h3>
            {current.note && (
              <p className="text-sm text-white/60 italic">{current.note}</p>
            )}
          </div>

          <div className="grid md:grid-cols-2 gap-x-12 gap-y-6">
            {current.items.map((item, idx) => (
              <div
                key={idx}
                data-testid={`menu-item-${current.id}-${idx}`}
                className="group"
              >
                <div className="flex items-baseline">
                  <h4 className="font-serif text-lg md:text-xl text-white group-hover:text-gold transition-colors">
                    {item.name}
                  </h4>
                  <span className="dotted-line" />
                  <span className="font-serif text-lg text-gold whitespace-nowrap font-semibold">
                    {item.price}
                  </span>
                </div>
                {item.desc && (
                  <p className="text-sm text-white/55 mt-1 italic">{item.desc}</p>
                )}
              </div>
            ))}
          </div>
        </div>

        <p className="text-center text-white/45 text-xs mt-8 max-w-2xl mx-auto">
          Alle Preise in Euro, inkl. gesetzlicher MwSt. Änderungen und Druckfehler vorbehalten.
        </p>
      </div>
    </section>
  );
}
